// extracted by mini-css-extract-plugin
export var md = "_44-4";
export var semantic = "_44-5";
export var sm = "_44-3";
export var text = "_44-6";
export var toggleInput = "_44-0";
export var toggleSwitch = "_44-1";
export var xs = "_44-2";